import React from 'react';

export const ChevronDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 15 10" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M7 5.32l5.41-5.2c.17-.16.34-.16.5 0l.97.94c.16.16.16.33 0 .5L7.25 7.91A.35.35 0 0 1 7 8a.35.35 0 0 1-.25-.09L.12 1.56c-.16-.17-.16-.34 0-.5l.97-.94c.16-.16.33-.16.5 0z"
			fill="currentColor"
			strokeWidth="0.3"
		/>
	</svg>
);
